import React, { useMemo, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { ShowMore } from '../ShowMore';
import { Heading } from './Heading';
import useIntersectionObserver from '../../../hooks/useIntersection';
import styles from './section.css';
var mapStateToProps = function (state) {
    return {
        deviceWidth: state.App.deviceWidth,
    };
};
var _Section = function (_a) {
    var _b, _c, _d;
    var title = _a.title, _e = _a.titleLevel, titleLevel = _e === void 0 ? 'h2' : _e, className = _a.className, children = _a.children, text = _a.text, link = _a.link, openInNewTab = _a.openInNewTab, _f = _a.onClick, onClick = _f === void 0 ? function () { return ({}); } : _f, deviceWidth = _a.deviceWidth, id = _a.id, _g = _a.inView, inView = _g === void 0 ? function () { } : _g, _h = _a.classes, classes = _h === void 0 ? {
        container: '',
        header: '',
        inner: '',
        showMore: ''
    } : _h;
    if (!children) {
        return React.createElement(React.Fragment, null);
    }
    var ref = useRef(null);
    var entry = useIntersectionObserver(ref, { freezeOnceVisible: true });
    var isVisible = !!(entry === null || entry === void 0 ? void 0 : entry.isIntersecting);
    useEffect(function () {
        if (isVisible)
            inView();
    }, [entry]);
    var renderShowMore = useMemo(function () {
        if (!text) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(ShowMore, { text: text, link: link, openInNewTab: openInNewTab, onClick: onClick, className: "".concat(styles.showMore, " ").concat(classes.showMore ? classes.showMore : '') });
    }, [text, link, onClick]);
    return React.createElement("section", { className: classNames((_b = {},
            _b[styles.container] = true,
            _b[className] = !!className,
            _b[classes.container] = !!classes.container,
            _b)), id: id, ref: ref },
        React.createElement("div", { className: classNames((_c = {},
                _c[styles.header] = true,
                _c[classes.header] = !!classes.header,
                _c)) },
            title && React.createElement(Heading, { headingLevel: titleLevel, heading: title, className: styles.title }),
            deviceWidth >= 768 && renderShowMore),
        React.createElement("div", { className: classNames((_d = {},
                _d[styles.inner] = true,
                _d[classes.inner] = !!classes.inner,
                _d)) }, children),
        deviceWidth < 768 && renderShowMore);
};
export var Section = connect(mapStateToProps)(_Section);
